import React, { useState } from "react";
import { bubble as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";
import ModalS from "components/UI/ModalS";
import {
  CLASSES_ACTIVITY_TYPE,
  SPORTS_ACTIVITY_TYPE,
  getSearcherRouteByType,
} from "../../shared/activityCatalog";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleStateChange = (state) => setMenuOpen(state.isOpen);

  const closeMenu = () => setMenuOpen(false);
  const currentState = props.location?.state || {};

  const getSearchNavigationState = (activityType) => {
    const currentActivityType =
      currentState.searchParams?.activityType ||
      (props.location?.pathname?.includes("/searcher/classes")
        ? CLASSES_ACTIVITY_TYPE
        : SPORTS_ACTIVITY_TYPE);
    const keepCurrentSearch =
      String(currentActivityType) === String(activityType);

    return {
      activityTypes: currentState.activityTypes,
      ...(keepCurrentSearch && currentState.searchParams
        ? { searchParams: currentState.searchParams }
        : {}),
    };
  };

  return (
    // Pass on our props
    <Menu isOpen={menuOpen} onStateChange={handleStateChange} {...props}>
      <Link
        className="menu-item"
        to={{
          pathname: getSearcherRouteByType(CLASSES_ACTIVITY_TYPE),
          state: getSearchNavigationState(CLASSES_ACTIVITY_TYPE),
        }}
        onClick={() => closeMenu()}
      >
        Todas las Clases
      </Link>

      <Link
        className="menu-item"
        to={{
          pathname: "/searcher",
          state: getSearchNavigationState(SPORTS_ACTIVITY_TYPE),
        }}
        onClick={() => closeMenu()}
      >
        Todas las Canchas
      </Link>

      <Link
        className="menu-item"
        to="/searcher/sportscenter"
        onClick={() => closeMenu()}
      >
        Centro Deportivos
      </Link>

      <ModalS
        closeMenu={closeMenu}
        isUser={props.isUser}
        setIsUser={props.setIsUser}
      />

      <small>Versión: {process.env.REACT_APP_VERSION}</small>
    </Menu>
  );
};
